import { icons } from './icons';
import { escapeHtml, formatPrice } from '@/lib/format';
import type { Product } from '@/api/types';

function durationLabel(days?: number | null): string {
  if (!days || days < 1) return 'TRIP';
  if (days === 1) return '1 GIORNO';
  return `${days} GIORNI`;
}

export function renderPcardSkeleton(count = 3): string {
  const one = `
    <div class="pcard-skeleton" aria-hidden="true">
      <div class="pcard-skeleton-hero">
        <span class="pcard-skeleton-badge"></span>
      </div>
      <div class="pcard-skeleton-body">
        <div class="pcard-skeleton-line w-40"></div>
        <div class="pcard-skeleton-line w-90"></div>
        <div class="pcard-skeleton-line w-70"></div>
        <div class="pcard-skeleton-foot">
          <div class="pcard-skeleton-line w-30"></div>
          <div class="pcard-skeleton-pill"></div>
        </div>
      </div>
    </div>`;
  return Array.from({ length: count }, () => one).join('');
}

export function renderPcard(p: Product): string {
  const title = escapeHtml(p.title ?? 'Padel experience');
  const shortDesc = escapeHtml(p.shortDescription ?? p.description ?? '');
  const cover = p.coverUrl ?? '';
  const dur = durationLabel(p.defaultDurationInDays);
  const price = p.price != null ? formatPrice(p.price, p.currency ?? 'EUR') : null;

  const hero = cover
    ? `<div class="pcard-hero-fallback"></div>
       <img class="pcard-hero-img" src="${escapeHtml(cover)}" alt="" loading="lazy" referrerpolicy="no-referrer" />`
    : `<div class="pcard-hero-fallback"></div>`;

  return `
    <button type="button" class="pcard" data-id="${escapeHtml(p.id)}">
      <div class="pcard-hero">
        ${hero}
        <span class="dur-badge">${icons.clock(11, '#111111')}${dur}</span>
        <span class="fav-btn" aria-hidden="true">${icons.heart(15, '#111111')}</span>
      </div>
      <div class="pcard-body">
        <div class="pcard-title">${title}</div>
        ${shortDesc ? `<div class="pcard-desc">${shortDesc}</div>` : ''}
        <div class="pcard-foot">
          <div class="pcard-price">${
            price ? `<em>da</em> ${price}` : '<em>su richiesta</em>'
          }</div>
        </div>
      </div>
    </button>
  `;
}
